const DAY_DURATION_MS = 24 * 60 * 60 * 1000;

type WeekdayProps = {
  date: Date;
  locale: string | undefined;
  timezone: number;
};

export const formatWeekday = ({ date, locale, timezone }: WeekdayProps) => {
  const offsetMs = timezone * 1000;

  const currentEpochDay = Math.floor((Date.now() + offsetMs) / DAY_DURATION_MS);
  const itemEpochDay = Math.floor(
    (date.getTime() + offsetMs) / DAY_DURATION_MS
  );

  const dayDiff = itemEpochDay - currentEpochDay;

  if (dayDiff === 0 || dayDiff === 1) {
    const relative = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });

    return relative.format(dayDiff, 'day');
  }

  const shiftedDate = new Date(date.getTime() + offsetMs);
  const formatter = new Intl.DateTimeFormat(locale, {
    weekday: 'long',
    timeZone: 'UTC'
  });

  return formatter.format(shiftedDate);
};
